module.exports = __webpack_public_path__ + "static/exhibitor-hero-default-19c40145605bae098c991326156e24d3.jpg";